import { ComponentClassName } from "@/types/utility"
import { cn } from "@/lib/utils"

export function SiteFooter({ className }: ComponentClassName) {
  return (
    <footer className={cn("flex justify-center py-0 md:py-0", className)}>
    </footer>
  )
}
